import { c as _c } from "react/compiler-runtime";
import './jumbotron-notable.scss';
import React from 'react';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { Card } from '../../../molecules/card/card.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
export const JumbotronNotable: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(39);
  let alt;
  let inline;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      seoLevel: t2,
      alt: t3,
      inline: t4,
      items: _items,
      ...t5
    } = t0;
    t1 = t2;
    alt = t3;
    inline = t4;
    props = t5;
    $[0] = t0;
    $[1] = alt;
    $[2] = inline;
    $[3] = props;
    $[4] = t1;
  } else {
    alt = $[1];
    inline = $[2];
    props = $[3];
    t1 = $[4];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  let T0;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== alt || $[6] !== inline || $[7] !== props || $[8] !== seoLevel) {
    const ratioClasses = {
      default: "aspect-ratio-1 @md:aspect-ratio-16-9",
      alt: "aspect-ratio-1 @md:aspect-ratio-16-9 @lg:aspect-ratio-21-9"
    };
    const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
    const t11 = !inline;
    if ($[19] !== alt || $[20] !== t11) {
      t10 = cn("JumbotronNotable component--container", {
        "JumbotronNotable--alt": alt,
        component: t11
      });
      $[19] = alt;
      $[20] = t11;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    const t12 = !inline;
    if ($[22] !== t12) {
      t9 = cn("JumbotronNotable__container flex", {
        container: t12
      });
      $[22] = t12;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    T0 = Card;
    t2 = props;
    t3 = getBaseSizeProps(headerDisplayLevel);
    t4 = seoLevel;
    t5 = seoLevel === 1 ? "lg" : "md";
    t6 = "background";
    t7 = "grow";
    t8 = cn("Card--single", alt ? ratioClasses.alt : ratioClasses.default);
    $[5] = alt;
    $[6] = inline;
    $[7] = props;
    $[8] = seoLevel;
    $[9] = T0;
    $[10] = t10;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[9];
    t10 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t11;
  if ($[24] !== T0 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t11 = <T0 {...t2} {...t3} seoLevel={t4} titleSize={t5} variant={t6} buttonVariant={t7} className={t8} hasPlaceholder={true} imageIntent="full" />;
    $[24] = T0;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== t9) {
    t12 = <div className={t9}>{t11}</div>;
    $[33] = t11;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t10 || $[37] !== t12) {
    t13 = <section className={t10}>{t12}</section>;
    $[36] = t10;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};